export type T_JSON_EVENT_DATA = {
  [key: string]: any
}

export type T_INITIAL_STATE_REDUCER = {
  nriLogin: boolean
  nativeDisplayEvents: Record<string, T_JSON_EVENT_DATA>
}

export const INITIAL_STATE: T_INITIAL_STATE_REDUCER = {
  nriLogin: false,
  nativeDisplayEvents: {}
}
